import { useState, useContext, useEffect } from "react";
import { FaCalculator, FaInfo, FaPrint, FaGraduationCap, FaQuestionCircle, FaRobot, FaCogs, FaEuroSign } from "react-icons/fa";
import ActionButton from "components/ui/controls/action-button";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import DropDown from "components/ui/controls/drop-down/drop-down";
import TextField from "components/ui/controls/text-field/text-field";
import Hover from "components/ui/controls/hover/hover";
import "components/app/styles/pageTitleStyles.css";
import { CustomTooltip } from "components/ui/controls/custom-tooltip/custom-tooltip";
import { Button } from "@mui/material";
import { createStyledButton } from "components/ui/controls/button/button-styles";

const RachatTrimestrePage = (props) => {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalAlertTauxPlein, setModalAlertTauxPlein] = useState(false);
  const [modalAlertDepassementTrimestre, setModalAlertDepassementTrimestre] = useState(false);
  const ClientConjoint = props.ClientConjoint;

  useEffect(() => {
    // ResultatTNS.GetResultBilanRetraite(context.state,"");
    // if(context.state.CarriereConjoint.length>0){
    //   ResultatTNS.GetResultBilanRetraite(context.state,"Conjoint");
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.ClientConjoint]);
  useEffect(() => {
    const totalTrim = Number(context.state["RachatTrimRU" + ClientConjoint]) + Number(context.state["RachatTrimCNAVPL" + ClientConjoint]);
    if (totalTrim > 12) {
      setModalAlertDepassementTrimestre(true);
      context.handleValueChange("RachatTrimRU" + ClientConjoint, 0);
      context.handleValueChange("RachatTrimCNAVPL" + ClientConjoint, 0);
    }
  }, [context.state["RachatTrimRU" + ClientConjoint], context.state["RachatTrimCNAVPL" + ClientConjoint]]);

  return (
    <>
      <Column fill>
        <Row>
          <Column fill>
            <div className="page-title-container">
              <div className="page-title-content">
                <div className="page-title-icon">
                  <FaGraduationCap />
                </div>
                <div className="page-title-text">
                  <h1>Rachat de trimestres</h1>
                  <p className="page-title-subtitle">Étudiez l'opportunité de racheter des trimestres pour optimiser la retraite de votre client</p>
                </div>
              </div>
              <div className="page-title-badge">
                <FaCalculator />
                <span>Simulation</span>
              </div>
            </div>
            <CardBox fill>
              <Column fill>
                <Row>
                  <CardBoxHeader icon={<FaCogs />}>
                    <span>Paramétrage du rachat de trimestres</span>
                  </CardBoxHeader>
                </Row>
                <Row >
                  <div className="revenuspro-container">
                    {/* Header séparé */}
                    <div className="header-card">
                      <div className="category-column">
                        <span className="header-icon">🏛️</span>
                        Régimes
                      </div>
                      <div className="value-column">
                        <span className="header-icon">📊</span>
                        Nombre de trimestres
                      </div>
                      <div className="value-column">
                        <span className="header-icon">⚙️</span>
                        Option de rachat
                      </div>
                      <div className="value-column"></div>
                    </div>

                    {/* Conteneur des cartes de contenu */}
                    <div className="card-list-container">
                      <div className="card">
                        <div className="category-column">Régime unifié</div>
                        <div className="value-column">
                          <TextField
                            disabled={
                              context.state["Carriere" + ClientConjoint].filter(
                                (Carriere) =>
                                  (Carriere.Nature === "RsiCommercant" ||
                                    Carriere.Nature === "RsiArtisan" ||
                                    Carriere.Nature === "ActiviteSalarie" ||
                                    Carriere.Nature === "SalarieNonCadre" ||
                                    Carriere.Nature === "SalarieCadre" ||
                                    Carriere.Nature === "SalarieNonCadreCFE" ||
                                    Carriere.Nature === "SalarieCadreCFE" ||
                                    Carriere.Nature === "SalarieNonCadreAgricole" ||
                                    Carriere.Nature === "SalarieCadreAgricole") &&
                                  Carriere.id !== "CarriereActuelle"
                              ).length > 0
                                ? false
                                : true
                            }
                            value={context.state["RachatTrimRU" + ClientConjoint]}
                            onChange={context.handleInputChange("RachatTrimRU" + ClientConjoint)}
                            dataType="uint"
                            normal
                          />
                        </div>
                        <div className="value-column">
                          <DropDown
                            value={context.state["RachatOptionRU" + ClientConjoint]}
                            onChange={context.handleInputChange("RachatOptionRU" + ClientConjoint)}
                            options={[
                              { value: "option1", label: "Option 1" },
                              { value: "option2", label: "Option 2" },
                            ]}
                            normal
                          />
                        </div>
                        <div className="value-column">
                          <CustomTooltip
                            tooltipStyle={{ minWidth: "300px", textAlign: "justify", padding: "14px" }}
                            type="info"
                            content={
                              <>
                                ✨ Le logiciel prévoit la possibilité de racheter des trimestres au titre : <br />
                                <br />- Des années incomplètes. <br />
                                <br />- Des années d’études supérieures (attention, le logiciel ne prévoit pas la réduction tarifaire en cas de rachat d’années d’études intervenant dans les
                                10 ans suivants les études). Nous vous rappelons que la demande de rachat s’effectue auprès du premier régime auquel l’assuré a été affilié après ses études.
                                <br />
                                <br />
                                Le rachat en option 1 influe sur le taux de pension et permet donc de réduire ou d’annuler la décote. Le rachat en option 2 influe sur le taux et la durée
                                d'assurance retenue pour le calcul de la retraite du régime unifié.
                              </>
                            }
                          >
                            <Button
                              icon
                              {...createStyledButton("card-action", "cardEdit", {
                                backgroundColor: "#dbeafe",
                                padding: "6px",
                                minWidth: "28px",
                                width: "44px",
                                height: "28px",
                              })}
                            >
                              <FaQuestionCircle className="icon-14px" style={{ color: "#3b82f6" }} />
                            </Button>
                          </CustomTooltip>
                        </div>
                      </div>

                      {/* Traitements et salaires */}
                      <div className="card">
                        <div className="category-column">CNAVPL</div>
                        <div className="value-column">
                          <TextField
                            disabled={
                              context.state["Carriere" + ClientConjoint].filter(
                                (Carriere) =>
                                  (Carriere.Nature === "Carcdsf" ||
                                    Carriere.Nature === "Carcdsf2" ||
                                    Carriere.Nature === "Carmf" ||
                                    Carriere.Nature === "Carpimko" ||
                                    Carriere.Nature === "Carpv" ||
                                    Carriere.Nature === "Cavec" ||
                                    Carriere.Nature === "Crn" ||
                                    Carriere.Nature === "Cavamac" ||
                                    Carriere.Nature === "Cavp" ||
                                    Carriere.Nature === "Cavom" ||
                                    Carriere.Nature === "MicroCipav" ||
                                    Carriere.Nature === "Cipav") &&
                                  Carriere.id !== "CarriereActuelle"
                              ).length > 0
                                ? false
                                : true
                            }
                            value={context.state["RachatTrimCNAVPL" + ClientConjoint]}
                            onChange={context.handleInputChange("RachatTrimCNAVPL" + ClientConjoint)}
                            dataType="uint"
                            normal
                          />
                        </div>
                        <div className="value-column">
                          <DropDown
                            value={context.state["RachatOptionCNAVPL" + ClientConjoint]}
                            onChange={context.handleInputChange("RachatOptionCNAVPL" + ClientConjoint)}
                            options={[
                              { value: "option1", label: "Trimestres" },
                              { value: "option2", label: "Trimestres + points" },
                            ]}
                            normal
                          />
                        </div>
                        <div className="value-column">
                          <CustomTooltip
                            tooltipStyle={{ minWidth: "300px", textAlign: "justify", padding: "14px" }}
                            type="info"
                            content={
                              <>
                                ✨ Le logiciel prévoit la possibilité de racheter des trimestres au titre : <br />
                                <br />- Des années incomplètes. <br />
                                <br />- Des années d’études supérieures (attention, le logiciel ne prévoit pas la réduction tarifaire en cas de rachat d’années d’études intervenant dans les
                                10 ans suivants les études). Nous vous rappelons que la demande de rachat s’effectue auprès du premier régime auquel l’assuré a été affilié après ses études.
                                <br /> <br />
                                Le professionnel libéral a la possibilité de racheter des trimestres et des points au régime de base de la CNAVPL. Le rachat d’un trimestre permet d’acquérir
                                des points supplémentaires selon le montant de rémunération déclaré.
                              </>
                            }
                          >
                            <Button
                              icon
                              {...createStyledButton("card-action", "cardEdit", {
                                backgroundColor: "#dbeafe",
                                padding: "6px",
                                minWidth: "28px",
                                width: "44px",
                                height: "28px"
                              })}
                            >
                              <FaQuestionCircle className="icon-14px" style={{ color: "#3b82f6" }} />
                            </Button>
                          </CustomTooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </Column>
            </CardBox>
          </Column>
        </Row>
        <Row>
          <Column fill>
            <CardBox>
              <Column>
                <Row tpad>
                  <CardBoxHeader icon={<FaEuroSign />}>
                    <span>Evaluation du coût du rachat</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField disabled className="invisibleRachatTrimestre-left" style={{ color: "black" }} value={"Revenus moyens"} normal />
                  </Column>
                  <Column rpad>
                    <TextField
                      value={context.state["RachatRevenus" + ClientConjoint]}
                      onChange={context.handleInputChange("RachatRevenus" + ClientConjoint)}
                      normal
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                    />
                  </Column>
                  <Column lpad>
                    <CustomTooltip
                      tooltipStyle={{ minWidth: "300px", textAlign: "justify", padding: "14px" }}
                      type="info"
                      content={
                        <>
                          ✨ Indiquez le montant des revenus professionnels des 3 années qui précèdent la demande pour déterminer le cout du rachat. Montant des salaires et le cas échéant
                          des revenus d'activité non salariée soumis à cotisations de sécurité sociale, non limités au plafond. Les autres revenus n'ont pas à être déclarés.
                        </>
                      }
                    >
                      <Button
                        icon
                        {...createStyledButton("card-action", "cardEdit", {
                          backgroundColor: "#dbeafe",
                          padding: "6px",
                          minWidth: "28px",
                          width: "44px",
                          height: "28px",
                        })}
                      >
                        <FaQuestionCircle className="icon-14px" style={{ color: "#3b82f6" }} />
                      </Button>
                    </CustomTooltip>
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField disabled className="invisibleRachatTrimestre-left" style={{ color: "black" }} value={"TMI en activité"} normal />
                  </Column>
                  <Column rpad>
                    <DropDown
                      value={context.state["RachatTMI" + ClientConjoint]}
                      onChange={context.handleInputChange("RachatTMI" + ClientConjoint)}
                      options={[
                        { value: 0, label: "0%" },
                        { value: 11, label: "11%" },
                        { value: 30, label: "30%" },
                        { value: 41, label: "41%" },
                        { value: 45, label: "45%" },
                      ]}
                      normal
                    />
                  </Column>
                  <Column lpad>
                    <CustomTooltip
                      tooltipStyle={{ minWidth: "300px", textAlign: "justify", padding: "14px" }}
                      type="info"
                      content={<>✨ Le montant du rachat est fiscalement déductible. Indiquez la TMI pour déterminer l’économie d’impôt réalisée grâce au rachat.</>}
                    >
                      <Button
                        icon
                        {...createStyledButton("card-action", "cardEdit", {
                          backgroundColor: "#dbeafe",
                          padding: "6px",
                          minWidth: "28px",
                          width: "44px",
                          height: "28px",
                        })}
                      >
                        <FaQuestionCircle className="icon-14px" style={{ color: "#3b82f6" }} />
                      </Button>
                    </CustomTooltip>
                  </Column>
                </Row>
                <Row>
                  <Column>
                    <TextField disabled className="invisibleRachatTrimestre-left" style={{ color: "black" }} value={"TMI à la retraite"} normal />
                  </Column>
                  <Column rpad>
                    <DropDown
                      value={context.state["RachatTMIRetraite" + ClientConjoint]}
                      onChange={context.handleInputChange("RachatTMIRetraite" + ClientConjoint)}
                      options={[
                        { value: 0, label: "0%" },
                        { value: 11, label: "11%" },
                        { value: 30, label: "30%" },
                        { value: 41, label: "41%" },
                        { value: 45, label: "45%" },
                      ]}
                      normal
                    />
                  </Column>
                  <Column lpad>
                    <CustomTooltip
                      tooltipStyle={{ minWidth: "300px", textAlign: "justify", padding: "14px" }}
                      type="info"
                      content={
                        <>
                          ✨ Fixer une TMI à la retraite permet de tenir compte de l'impôt supplémentaire liée à l'augmentation de la pension de retraite. L'étude du retour sur
                          investissement de l'opération sera donc plus précise.
                        </>
                      }
                    >
                      <Button
                        icon
                        {...createStyledButton("card-action", "cardEdit", {
                          backgroundColor: "#dbeafe",
                          padding: "6px",
                          minWidth: "28px",
                          width: "44px",
                          height: "28px",
                        })}
                      >
                        <FaQuestionCircle className="icon-14px" style={{ color: "#3b82f6" }} />
                      </Button>
                    </CustomTooltip>
                  </Column>
                </Row>
              </Column>
            </CardBox>
          </Column>
          <Column fill>
            <CardBox fill>
              <Column fill>
                <Row tpad>
                  <CardBoxHeader icon={<FaPrint />}>
                    <span>Actions</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <Column fill>
                    <Row>
                      <ActionButton
                        disabled={context.state["RachatRevenus" + ClientConjoint].toString() === "0" ? true : false}
                        variant="success"
                        icon={<FaPrint />}
                        title="Imprimer l'étude"
                        subtitle="Générer le rapport de rachat"
                        onClick={() => {
                          ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.TotalTrimestre >=
                          ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.Infos?.DureeReference
                            ? setModalAlertTauxPlein(true)
                            : ResultatTNS.GetResultRachatTrimestre(context.state, context.state["CarriereSalaireReference" + ClientConjoint], ClientConjoint);
                        }}
                      />
                    </Row>
                    <Row tpad>
                      <ActionButton
                        variant="warning"
                        icon={<FaRobot />}
                        title="Mon assistant virtuel"
                        subtitle="Aide à la saisie"
                        onClick={() => {
                          // TODO: Ajouter la logique pour l'assistant à la saisie
                          console.log("Assistant à la saisie cliqué");
                        }}
                      />
                    </Row>
                  </Column>
                </Row>
              </Column>
            </CardBox>
          </Column>
        </Row>
      </Column>
      <Modal
        width="50%"
        height="20%"
        title=" "
        visible={modalAlertTauxPlein}
        onClose={() => {
          setModalAlertTauxPlein(false);
        }}
      >
        <Row fill center>
          <Column fill center>
            <h3>Il n'est pas possible de racheter des trimestres dans le cadre d'un départ au taux plein.</h3>
          </Column>
        </Row>
      </Modal>

      <Modal
        width="50%"
        height="20%"
        title=" "
        visible={modalAlertDepassementTrimestre}
        onClose={() => {
          setModalAlertDepassementTrimestre(false);
        }}
      >
        <Row fill center>
          <Column fill center>
            <h3>Il n'est pas possible de racheter plus de 12 trimestres.</h3>
          </Column>
        </Row>
      </Modal>
    </>
  );
};

export default RachatTrimestrePage;
